/* global App */
const esp = require('router-maggie/esp')
const cri = require('router-maggie/cri')

module.exports = { esp, cri }
